module.exports = __webpack_public_path__ + "static/media/etiqa_logo_NDC.a9209501.png";